import { FunctionComponent } from "react";
import { useParams } from "react-router-dom";
import { IonPage, IonSpinner, IonText } from "@ionic/react";
import { AllParams, ParamsNames } from "../../../modules/router/constantes/paramsNames";
import { PlanComponent } from "../../../modules/plan/components/plan.component";
import { useUserContext } from "../../../modules/user/contexts/user.context";
import { RouteBuilder } from "../../../modules/router/constantes/routes.const";
import { MappedAreaService } from "../../../modules/plan/services/mapped-area.service";
import { AnnotationOutdoorAreasService } from "../../../modules/plan/services/annotation.service";
import { AttributeOutdoorAreasService } from "../../../modules/plan/services/attribute.service";
import { MetaLibraryService } from '../../../modules/plan/services/meta-library.service';
import { useAnnotationsWithLibrary } from '../../../modules/annotation/hooks';
import { useOrganizationCode } from "../../../modules/router/hooks/use-organization-code.hook";
import { useLocale } from "../../../modules/router/hooks/use-locale.hook";

export const OutdoorAreasPage: FunctionComponent = () => {
  const params = useParams<Pick<AllParams, ParamsNames.SITE_ID | ParamsNames.FILE_NAME>>();

  const { currentOrganization, hasUser } = useUserContext();
  const { getOutdoorAreasAnnotations } = useAnnotationsWithLibrary();
  const organizationCode = useOrganizationCode();
  const locale = useLocale();

  // Afficher un loader si l'organisation n'est pas encore chargée
  if (!hasUser || !currentOrganization) {
    return (
      <IonPage>
        <IonSpinner />
        <IonText>Chargement...</IonText>
      </IonPage>
    );
  }

  const codeOrganization = currentOrganization.code;

  return (
    <PlanComponent
      planId={params.siteId}
      backRoute={RouteBuilder.site(params.siteId, locale, organizationCode)}
      getPlan={() => MappedAreaService.getOutdoorAreasMappedArea(codeOrganization, params.siteId)}
      getAnnotation={() => getOutdoorAreasAnnotations(codeOrganization, params.siteId)}
      getAttributes={(assetId) => AttributeOutdoorAreasService.getAttributes(codeOrganization, params.siteId, assetId)}
      updateAttribute={(componentId, attributeId, updateAttribute) =>
        AttributeOutdoorAreasService.updateAttribute(codeOrganization, componentId, attributeId, {
          ...updateAttribute,
          siteId: params.siteId,
          buildingId: params.siteId,
          floorId: params.siteId,
          componentId,
          id: attributeId,
        })
      }
      createAnnotation={(annotation) =>
        AnnotationOutdoorAreasService.createAnnotation(codeOrganization, {
          ...annotation,
          siteId: params.siteId,
          buildingId: params.siteId,
          floorId: params.siteId,
        })
      }
      updateAnnotation={(...args) =>
        AnnotationOutdoorAreasService.updateAnnotation(codeOrganization, params.siteId, ...args)
      }
      deleteAnnotation={(annotationId) =>
        AnnotationOutdoorAreasService.deleteAnnotation(codeOrganization, annotationId, params.siteId, params.fileName)
      }
      getCharacteristics={(componentTypeCodes) => {
        return MetaLibraryService.getCharacteristics(codeOrganization, componentTypeCodes);
      }}
    />
  );
};
